import React, { useContext } from 'react'
import { Box } from '../../Components/Layout'
import { MatchupContext } from '../../Context'
import { SectionHeading } from '../../Components/Headers'
import { Media } from './components/media/Media'
import { ReadMore, WriteupCon } from './styles'
import { MatchupStandings } from './components/Standings/MatchupStandings'

export const Summary: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { eventInfo, matchupInfo } = useContext(MatchupContext)!

  return (
    <>
      {eventInfo && (
        <Box noMargin boxColor="grey">
          <SectionHeading lowMargin headingColor="light">
            <strong>Matchup Summary</strong>
          </SectionHeading>
          <WriteupCon
            dangerouslySetInnerHTML={{
              __html: matchupInfo?.matchupPreview || '',
            }}
          />
          {matchupInfo?.articleLink && (
            <ReadMore href={matchupInfo?.articleLink || '#'} aria-label="Read More">
              Read More
            </ReadMore>
          )}
        </Box>
      )}
      <Media />
      <MatchupStandings />
    </>
  )
}
